<!-- eslint-disable @typescript-eslint/no-non-null-assertion -->
<script setup lang="ts">
import type { Editor } from '@tiptap/vue-3'
import { computed, ref, unref } from 'vue'
import { DropdownMenuCheckboxItem } from '@/foundation/dropdown-menu'
import ActionDropdownButton from '@/notebook/components/ActionDropdownButton.vue'
import { useLocale } from '@/notebook/locales'
import type { ButtonViewReturnComponentProps } from '@/notebook/type'

const { t } = useLocale()

function percentageToDecimal(percentageString) {
  // 去掉百分号并转换成数字
  const percentage = parseFloat(percentageString.replace('%', ''))
  // 将百分比转换成小数
  const decimal = percentage / 100

  return decimal
}
const LineHeights = computed(() => {
  const lineHeightOptions = props.editor.extensionManager.extensions.find((e) => e.name === 'lineHeight')!.options
  const a = lineHeightOptions.lineHeights
  const b = a.map((item) => ({
    label: percentageToDecimal(item),
    value: item,
  }))

  b.unshift({
    label: unref(t)('editor.default'),
    value: 'default',
  })

  return b
})

const value = ref('default')

type Props = {
  editor: Editor
  icon?: any
  tooltip?: string
  disabled?: boolean
  action?: ButtonViewReturnComponentProps['action']
  isActive?: ButtonViewReturnComponentProps['isActive']
}

const props = withDefaults(defineProps<Props>(), {
  icon: undefined,
  tooltip: undefined,
  disabled: false,
  action: undefined,
  isActive: undefined,
})

function toggleLightheight(key: string) {
  if (key === 'default') {
    props.editor.commands.unsetLineHeight()
  } else {
    props.editor.commands.setLineHeight(key)
  }
  value.value = key
}
</script>

<template>
  <ActionDropdownButton :icon="icon" :tooltip="tooltip" :disabled="disabled">
    <DropdownMenuCheckboxItem
      v-for="(item, index) in LineHeights"
      :key="index"
      :checked="item.value === value"
      @click="toggleLightheight(item.value)"
    >
      {{ item.label }}
    </DropdownMenuCheckboxItem>
  </ActionDropdownButton>
</template>
